module.exports = __webpack_public_path__ + "static/img/30.0a016f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/30.png
// module id = US8l
// module chunks = 1